module.exports = __webpack_public_path__ + "static/media/512x512.fdbed7f1.png";